import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-partnership-hero',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './partnership-hero.component.html',
})
export class PartnershipHeroComponent {}
